import React from 'react'

import Currency from 'react-currency-formatter'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import DetailCard from '@components/UI/DetailCard'
import { IApplicationState } from '@store'
import {
  selectAnalyticsActions,
  selectAnalyticsCostPerView,
  selectAnalyticsCostPerViewCurrency,
  selectAnalyticsFollowers,
  selectAnalyticsImpressions,
  selectAnalyticsStoryViewRate,
  selectAnalyticsUniqueViews,
} from '@store/performance'
import { selectSubmissionId } from '@store/router'
import { abbreviateNumberOrDash } from '@utils'
import { PerformanceDetailCardWithEmptyDefault } from '../Details'
import { PerformanceDetailCardGrid, PerformanceDetailCardWrapper } from '../Details.styled'

export const SubmissionPerformanceDetailsStory: React.FC = () => {
  const match = useRouteMatch()
  const submissionId = selectSubmissionId(match)!

  const followers = useSelector((state: IApplicationState) => selectAnalyticsFollowers(state, submissionId))
  const impressions = useSelector((state: IApplicationState) => selectAnalyticsImpressions(state, submissionId)) as
    | number
    | undefined
  const uniqueViews = useSelector((state: IApplicationState) => selectAnalyticsUniqueViews(state, submissionId))
  const storyViewRate = useSelector((state: IApplicationState) => selectAnalyticsStoryViewRate(state, submissionId))
  const actions = useSelector((state: IApplicationState) => selectAnalyticsActions(state, submissionId))
  const costPerView = useSelector((state: IApplicationState) => selectAnalyticsCostPerView(state, submissionId))
  const costPerViewCurrency = useSelector((state: IApplicationState) => selectAnalyticsCostPerViewCurrency(state, submissionId))

  return (
    <PerformanceDetailCardGrid>
      <PerformanceDetailCardWrapper>
        <DetailCard
          title={<FormattedMessage id={`submission.performance.followers`} />}
          content={abbreviateNumberOrDash(followers)}
          elementName="story-submission-followers"
        />
      </PerformanceDetailCardWrapper>
      <PerformanceDetailCardWithEmptyDefault
        elementName="story-submission-impressions"
        title={<FormattedMessage id={`submission.performance.impressions`} />}
        content={<FormattedNumber value={impressions!} />}
        value={impressions}
      />
      <PerformanceDetailCardWithEmptyDefault
        elementName="story-submission-unique-views"
        title={<FormattedMessage id={`submission.performance.uniqueViews`} />}
        content={<FormattedNumber value={uniqueViews!} />}
        value={uniqueViews}
      />
      <PerformanceDetailCardWithEmptyDefault
        elementName="story-submission-story-view-rate"
        title={<FormattedMessage id={`submission.performance.storyViewRate`} />}
        content={<FormattedMessage id="core.text.percent" values={{ value: storyViewRate }} />}
        value={storyViewRate}
      />
      <PerformanceDetailCardWithEmptyDefault
        elementName="story-submission-actions"
        title={<FormattedMessage id={`submission.performance.actions`} />}
        content={<FormattedNumber value={actions!} />}
        value={actions}
      />
      <PerformanceDetailCardWithEmptyDefault
        elementName="story-submission-cost-per-view"
        title={<FormattedMessage id={`submission.performance.costPerView`} />}
        content={<Currency currency={costPerViewCurrency} quantity={costPerView} />}
        value={costPerView}
      />
    </PerformanceDetailCardGrid>
  )
}

export default SubmissionPerformanceDetailsStory
